import { VideoProvider } from '@front-app/components/video/util';

/**
 * Given an iframe-based embed code, extracts the URL for the video.
 *
 * @param embedCode A string embed code, for example from youtube.com
 * @returns The src url from the embed's iframe
 */
export function extractEmbedSrc(embedCode: string): string {
	const container = document.createElement('div');
	container.innerHTML = embedCode;
	const iframe = container.querySelector('iframe');
	if (!iframe) {
		return '';
	}
	return iframe.src;
}

export const extractVideoIdFromUrl = (urlAsString: string, type: VideoProvider | null): string => {
	const url = new URL(urlAsString);

	if (type === VideoProvider.YOUTUBE) {
		const v = url.searchParams.get("v");
		if (v) {
			return v;
		}
	}

	const urlParts = url.pathname.split('/');
	return urlParts[urlParts.length - 1];
}

export function convertVideoIdToUrl(id: string, type: VideoProvider | null): string {
	switch (type) {
	case VideoProvider.YOUTUBE:
		return `https://www.youtube.com/watch?v=${id}`;
	case VideoProvider.VIMEO:
		return `https://vimeo.com/${id}`;
	default:
		return '';
	}
}
